import { css } from '@emotion/react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Link, Typography } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../universal-nav/hooks';
const Styles = {
    root: css `
    display: grid;
    grid-template-columns: 100%;
    gap: 10px;
    justify-items: center;
    ${Typography.smallPrint3};
    text-align: center;

    @media screen and (min-width: 650px) {
      gap: 20px;
    }
  `,
    title: css `
    color: ${Colors.neutral800};
    ${Typography.paragraph3Bold};
  `,
    links: css `
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  `,
    link: css `
    ${Typography.paragraph3}
    // Increase hit size.
    display: block;
    padding: 0px;
    margin: 0px 10px;
    white-space: nowrap;
    flex: none;
    color: ${Colors.neutral700};
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors.blue};
      outline: none;
    }

    @media screen and (max-width: 768px) {
      margin: 0px 6px;
    }
  `,
};
const letters = ['0–9', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];
export const AlphabeticAppNav = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const linkItems = letters.map((letter) => {
        const href = `${props.baseUrl}/${letter.toLowerCase()}`
            .replace('//', '/')
            .replace('–', '-');
        return (isolateComponent("li", { key: letter },
            isolateComponent(Link, { ariaLabel: `${letter} — Apps beginning with ${letter}`, color: null, css: Styles.link, href: getFullyQualifiedURL(href) }, letter)));
    });
    return (isolateComponent("section", { css: Styles.root },
        isolateComponent("h2", { css: Styles.title }, props.title),
        isolateComponent("ul", { css: Styles.links }, linkItems)));
};
AlphabeticAppNav.defaultProps = {
    baseUrl: '/find-apps/',
    title: 'Apps by Title',
};
//# sourceMappingURL=AlphabeticAppNav.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
